import { API_URL } from '@/api.js';

// Holt den aktuell gespielten Spotify-Track über den Backend-Proxy.
// Die Spotify-Secrets liegen serverseitig (siehe portfolio-backend/src/api/spotify),
// nicht mehr im Frontend-Bundle. Rückgabe ist ein fetch-Response, damit der
// Consumer (SpotifySong.vue) unverändert `response.status` / `response.json()` nutzt.
export const getNowPlaying = () => fetch(`${API_URL}/now-playing`);
